import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { getProgramQueryKey } from '../../../../queries/keys';

export const useReloadProgram = () => {
  const queryClient = useQueryClient();

  return useCallback(
    async (programId: string) => {
      await queryClient.invalidateQueries({ queryKey: getProgramQueryKey({ programId }) });
    },
    [queryClient],
  );
};
